import { Injectable } from '@angular/core'
import { MatDialogConfig, MatDialogRef } from '@angular/material/dialog'
import { ComponentType } from '@angular/cdk/portal'
import { ConnectionView } from '@tv3/store/connection/connection.view'
import { DialogService } from '@tokeet-frontend/tv3-platform'
import { HopperConnectionOverlayComponent } from './hopper-connection-overlay.component'

@Injectable({
  providedIn: 'root',
})
export class HopperConnectionOverlayService {
  constructor(private dialog: DialogService) {}

  public open<T>(connection: ConnectionView, component: ComponentType<T>): MatDialogRef<T> {
    const defaultConfig: MatDialogConfig = {
      data: { connection },
      panelClass: ['drawer-full-80'],
    }

    const dialogRef = this.dialog.openDrawer(component, defaultConfig)

    return dialogRef
  }

  public openSide(connection: ConnectionView) {
    return this.open(connection, HopperConnectionOverlayComponent)
  }
}
